/* eslint-disable camelcase */
const messages = {
  max: (field: string, { length }: { length: number }) => `Pole smí obsahovat najviac ${length} znaků.`,
  min: (field: string, { length }: { length: number }) => `Pole musí obsahovat minimálně ${length} ${length < 4 ? 'znaky' : 'znaků'}.`,
  required: () => 'Pole je povinné.'
}

export default { code: 'sk', messages }
